/**
 * Cash-Up Constants and Utilities
 */

// South African denominations
export const NOTE_DENOMINATIONS = [200, 100, 50, 20, 10];
export const COIN_DENOMINATIONS = [5, 2, 1, 0.50, 0.20, 0.10, 0.05];

// Format currency in South African Rand
export const formatCurrency = (value) => {
  return `R ${(value || 0).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Empty daily form state
export const EMPTY_DAILY_FORM = {
  cashUpNo: '',
  pettyCash: 0,
  refunds: 0,
  accPayment: 0,
  note200: 0,
  note100: 0,
  note50: 0,
  note20: 0,
  note10: 0,
  change: 0,
  speedpointBatchNo: '',
  speedpointAmount: 0,
};

// Calculate totals from note counts
export const calculateNotesTotal = (noteCounts) => {
  return NOTE_DENOMINATIONS.reduce((sum, d) => sum + (noteCounts[d] || 0) * d, 0);
};

// Calculate totals from coin counts
export const calculateCoinsTotal = (coinCounts) => {
  return COIN_DENOMINATIONS.reduce((sum, d) => sum + (coinCounts[d] || 0) * d, 0);
};

// Calculate daily form totals
export const calculateDailyFormTotals = (dailyForm) => {
  const notesTotal = 
    (dailyForm.note200 || 0) * 200 +
    (dailyForm.note100 || 0) * 100 +
    (dailyForm.note50 || 0) * 50 +
    (dailyForm.note20 || 0) * 20 +
    (dailyForm.note10 || 0) * 10;
  
  const totalCash = notesTotal + (dailyForm.change || 0);
  
  return { notesTotal, totalCash };
};
